import {
  CHECK_KTI_RULES_ENABLED_REQUEST,
  CHECK_KTI_RULES_ENABLED_SUCCESS,
  CHECK_KTI_RULES_ENABLED_ERROR,
  FETCH_KTI_RULES_REQUEST,
  FETCH_KTI_RULES_SUCCESS,
  FETCH_KTI_RULES_ERROR,
  UPDATE_KTI_RULES_REQUEST,
  UPDATE_KTI_RULES_SUCCESS,
  UPDATE_KTI_RULES_ERROR,
  PUBLISH_KTI_RULES_REQUEST,
  PUBLISH_KTI_RULES_SUCCESS,
  PUBLISH_KTI_RULES_ERROR,
} from '../actions/ktiRulesActions';
import { KTI_RULE_MODE } from '../containers/Returns/KtiRules/constants';

const initialState = {
  loading: false,
  error: null,
  visible: false,
  hasUnpublishedChanges: false,
  data: {
    timerange_in_days: null,
    mode: KTI_RULE_MODE.DISABLED,
    config: {
      threshold_config: {
        config_values: [],
      },
    },
  },
};

const ktiRulesReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHECK_KTI_RULES_ENABLED_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CHECK_KTI_RULES_ENABLED_SUCCESS:
      return {
        ...state,
        loading: false,
        visible: action.payload.payload?.enabled || false,
        error: null,
      };

    case CHECK_KTI_RULES_ENABLED_ERROR:
      return {
        ...state,
        loading: false,
        visible: false,
        error: null,
      };

    case FETCH_KTI_RULES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_KTI_RULES_SUCCESS: {
      const newData = action.payload.payload || action.payload;
      return {
        ...state,
        loading: false,
        data: newData,
        error: null,
      };
    }

    case FETCH_KTI_RULES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_KTI_RULES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case UPDATE_KTI_RULES_SUCCESS: {
      const newData = action.payload.payload || action.payload;
      return {
        ...state,
        loading: false,
        data: newData,
        error: null,
        hasUnpublishedChanges: true,
      };
    }

    case UPDATE_KTI_RULES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PUBLISH_KTI_RULES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case PUBLISH_KTI_RULES_SUCCESS: {
      const newData = action.payload.payload || action.payload;
      return {
        ...state,
        loading: false,
        data: newData || state.data,
        hasUnpublishedChanges: false,
        error: null,
      };
    }

    case PUBLISH_KTI_RULES_ERROR:
      return {
        ...state,
        loading: false,
        hasUnpublishedChanges: true,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default ktiRulesReducer;
